export class TemplateModel {
    constructor(data) {
        this.id = data.template_id;
        this.name = data.template_name;
        this.html = data.template_html;
        this.createdAt = new Date(data.template_created_at);
        this.updatedAt = new Date(data.template_updated_at);
    }

    static fromJson(json) {
        return new TemplateModel(json.template);
    }
} 